<template>
    <div v-if="showDialog" class="mask">
        <div class="msgbox">
            <div class="msg_title">温馨提示</div>
            <div class="msg_content">{{ msg }}</div>
            <div @click="close()" class="msg_btn">{{ confirmText }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            msg: '',
            showDialog: false,
            confirmText: '我知道了'
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.body.appendChild(this.$el);
        });
    },
    methods: {
        open(msg) {
            this.msg = msg;
            this.showDialog = true;
            document.body.style.overflow = "hidden";
        },
        close() {
            this.showDialog = false;
            document.body.style.overflow = "auto";
        }
    }
}
</script>

<style scoped lang="less">
.mask {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.74);
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    .msgbox {
        width: 3.2rem;
        background: #ffffff;
        border-radius: 0.12rem;
        padding: 0.26rem 0.35rem;
        box-sizing: border-box;
        text-align: center;

        .msg_title {
            font-size: 0.18rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #000000;
            line-height: 0.25rem;
        }

        .msg_content {
            font-size: 0.16rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 0.26rem;
            margin-top: 0.14rem;
            max-height: 2rem;
            overflow: auto;
            word-break: break-all;
        }

        .msg_btn {
            margin-top: 0.18rem;
            width: 2.5rem;
            height: 0.44rem;
            line-height: 0.44rem;
            background: #0081f6;
            border-radius: 0.07rem;
            font-size: 0.16rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #ffffff;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/components/msgBox.vue